// Only website links and local routes are supported, including for older CMS data.
export function safeToolUrl(value, allowLocal = false) {
  if (typeof value !== 'string' || !value.trim() || value.includes('\\')) return null;
  const url = value.trim();
  if (allowLocal && /^\/(?!\/)/.test(url)) return url;
  try {
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol) ? parsed.href : null;
  } catch {
    return null;
  }
}
